import { SegmentNotFound } from "@domains/segments/client/components/SegmentNotFound.tsx";
import { ORPCError } from "@orpc/client";
import { useRouteError } from "react-router";

export function SegmentFormErrorBoundary() {
    const error = useRouteError();

    if (error instanceof ORPCError && error.code === "NOT_FOUND") {
        return <SegmentNotFound segmentsListPath="/settings/segments" />;
    }

    throw error;
}
